module.exports = __webpack_public_path__ + "static/media/2019-Raptor.41b65d3d.webp";